export const APP_CONFIG = {
  APP_NAME: 'Plus+ Talent',
  COMPANY_NAME: 'Plus+ Talent Analytics',
  SUPPORT_EMAIL: 'support@plustalent.ai',
};

export const PRICING = {
  ENTERPRISE: {
    name: 'Enterprise Plan',
    priceString: 'Contact for pricing',
    price: 0, // Custom pricing
    period: 'month',
    features: [
      '100 user licenses included',
      '1,000 analyses per license per month',
      'Advanced AI matching & insights',
      'Custom interview plans & assessments',
      'Technical skill evaluation',
      'Market intelligence & benchmarking',
      'Priority enterprise support',
      'Advanced analytics dashboard',
      'Job description generator',
      'Bulk analysis capabilities',
      'API access & integrations',
      'Custom training & onboarding',
      'Dedicated account manager',
      'SLA guarantees',
      'Advanced security & compliance'
    ]
  }
};

export const AUTH_ERRORS = {
  INVALID_CREDENTIALS: 'Invalid email or password',
  EMAIL_IN_USE: 'Email already in use',
  WEAK_PASSWORD: 'Password must be at least 8 characters',
};

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  ONBOARDING: '/onboarding',
  DASHBOARD: '/dashboard',
  PRICING: '/pricing',
};